(() => {
  const houseCodes = ['PELMORI-WAKE-2-10', 'PELMORI-WAKE-3-20', 'PELMORI-WAKE-2-400-DRAFT', 'PELMORI-2WATCH'];
  const request = async (root, path, body) => {
    const response = await fetch(root + path, body === undefined ? {credentials:'same-origin',cache:'no-store'} : {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const value = await response.json();
    if (!response.ok) throw new Error(value.description || value.message || 'Cart error');
    return value;
  };
  const syncOffer = async (root, cart) => {
    const count = cart.items.filter(item => item.handle === 'silent-wake-watch').reduce((sum,item) => sum + item.quantity,0);
    const active = (cart.discount_codes || []).map(item => item.code);
    const other = active.filter(code => !houseCodes.includes(code.toUpperCase()));
    const expected = count >= 3 ? houseCodes[1] : count >= 2 ? houseCodes[3] : '';
    const desired = [...other,...(expected ? [expected] : [])];
    if (active.map(x => x.toUpperCase()).sort().join(',') === desired.map(x => x.toUpperCase()).sort().join(',')) return cart;
    return request(root,'cart/update.js',{discount:desired.join(',')});
  };
  function initProduct(el) {
    if (el.dataset.ready || !el.querySelector('[data-product-json]')) return;
    el.dataset.ready = 'true';
    const data = JSON.parse(el.querySelector('[data-product-json]').textContent);
    const labels = data.labels;
    const root = el.dataset.root;
    const form = el.querySelector('.cro-buy-form');
    const select = el.querySelector('[data-variant]');
    const isWatch = el.dataset.key === 'watch';
    const image = el.querySelector('.cro-main-image img');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:el.dataset.currency || 'USD'}).format(cents / 100);
    let quantity = 1;
    let busy = false;
    let added = false;
    let total = 0;
    const variant = id => data.variants.find(item => String(item.id) === String(id));
    const setImage = (url,alt) => {if(!url)return; image.removeAttribute('srcset'); image.src=url;image.alt=alt || '';};
    const refresh = (changeImage=false) => {
      const current = variant(select.value);
      if(!current)return;
      const chosen = [current];
      if(isWatch)for(let n=2;n<=quantity;n++)chosen.push(variant(el.querySelector(`[data-extra-variant="${n}"]`).value));
      const discount = isWatch && quantity>=3 ? .2 : 0;
      const allAvailable = chosen.length===quantity && chosen.every(item => item && item.available);
      total = chosen.reduce((sum,item) => sum + Math.round((item?.price || 0) * (1-discount)),0);
      if (isWatch && quantity === 2) total = Math.max(0,total - 400);
      el.querySelector('[data-price]').textContent = money(current.price);
      const compare = el.querySelector('[data-compare]');
      const hasCompare = Number(current.compare_at_price) > Number(current.price);
      compare.hidden = !hasCompare;
      compare.textContent = hasCompare ? money(current.compare_at_price) : '';
      const savings = el.querySelector('[data-price-savings]');
      if (savings) {
        savings.hidden = !hasCompare;
        savings.textContent = hasCompare ? 'Save ' + money(current.compare_at_price - current.price) : '';
      }
      el.querySelector('[data-add-label]').textContent = allAvailable ? `${labels.add} — ${money(total)}` : labels.sold;
      el.querySelector('[data-add]').disabled = !allAvailable || busy;
      el.querySelector('[data-sticky-add]').disabled = !allAvailable || busy;
      el.querySelector('[data-sticky-price]').textContent = money(total);
      el.querySelector('[data-quantity]').value = quantity;
      if(isWatch){
        el.querySelectorAll('[data-offer-price]').forEach(node => {const q=Number(node.dataset.offerPrice);node.textContent=money(q===2 ? current.price*2-400 : Math.round(current.price*(q===3?.8:1))*q);});
        el.querySelectorAll('[data-offer-each]').forEach(node => {const q=Number(node.dataset.offerEach);node.textContent=q>1?(money(q===2 ? current.price-200 : Math.round(current.price*.8)) + ' ' + labels.each):'';});
        el.querySelectorAll('[data-swatch]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.swatch===String(current.id))));
        el.querySelectorAll('[data-extra]').forEach(node => node.hidden=Number(node.dataset.extra)>quantity);
        el.querySelector('[data-shipping]').textContent=quantity>1?labels.bundleShipping:labels.singleShipping;
        el.querySelector('[data-bundle-terms]').hidden=quantity===1;
      }
      if(changeImage){
        if(el.dataset.key!=='nasal')setImage(current.featured_image?.src || data.fallbackImage,current.title);
        if(location.protocol==='https:'||location.protocol==='http:'){const url=new URL(location.href);url.searchParams.set('variant',current.id);history.replaceState(null,'',url);}
        el.querySelectorAll('.cro-thumb[data-image]').forEach(button=>button.setAttribute('aria-pressed','false'));
        el.dispatchEvent(new CustomEvent('cro:variant-image'));
      }
    };
    if(isWatch){el.querySelector('[data-offers]').hidden=false;el.querySelectorAll('[name="cro-set"]').forEach(radio=>radio.addEventListener('change',()=>{quantity=Number(radio.value);refresh();}));}
    select.addEventListener('change',()=>refresh(true));
    el.querySelectorAll('[data-swatch]').forEach(button=>button.addEventListener('click',()=>{select.value=button.dataset.swatch;refresh(true);}));
    el.querySelectorAll('[data-extra-variant]').forEach(input=>input.addEventListener('change',()=>refresh()));
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy || added)return;
      busy=true;const error=el.querySelector('[data-error]');error.hidden=true;
      el.querySelectorAll('[data-add],[data-sticky-add]').forEach(button=>button.disabled=true);
      el.querySelector('[data-add-label]').textContent=labels.adding;
      const items=[{id:Number(select.value),quantity:1}];
      if(isWatch)for(let n=2;n<=quantity;n++)items.push({id:Number(el.querySelector(`[data-extra-variant="${n}"]`).value),quantity:1});
      const merged=Object.values(items.reduce((map,item)=>{if(map[item.id])map[item.id].quantity++;else map[item.id]={...item};return map;},{}));
      try{
        await request(root,'cart/add.js',{items:merged});added=true;
        const cart=await request(root,'cart.js');
        await syncOffer(root,cart);
        location.assign(el.dataset.cart);
      }catch(failure){
        error.textContent=added?labels.addedError:(failure.message || labels.error);error.hidden=false;
        el.querySelector('[data-error-cart]').hidden=!added;
        busy=false;
        if(!added)refresh();
      }
    });
    const sticky=el.querySelector('[data-sticky]');el.querySelector('[data-sticky-add]').addEventListener('click',event=>{if(sticky.dataset.before==='true'){event.preventDefault();form.scrollIntoView({behavior:'smooth',block:'start'});}});
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting;sticky.dataset.before=String(entry.boundingClientRect.top>0);el.querySelector('[data-sticky-add]').textContent=entry.boundingClientRect.top>0?labels.choose:labels.add;},{threshold:0});observer.observe(el.querySelector('[data-add]'));}
    refresh();
  }
  function initCart(el){
    if(el.dataset.ready)return;
    el.dataset.ready='true';
    const form=el.querySelector('form');
    if(!form)return;
    const root=el.dataset.root;
    const sectionId=el.dataset.sectionId;
    const error=el.querySelector('[data-cart-error]');
    const status=el.querySelector('[data-cart-status]');
    const labels=JSON.parse(el.querySelector('[data-cart-labels]').textContent);
    const checkoutButton=form.querySelector('[data-cart-checkout]');
    if(checkoutButton)checkoutButton.disabled=false;
    let busy=false;
    let debounce=null;
    const inputs=()=>Array.from(form.querySelectorAll('input[data-line]'));
    const controls=()=>Array.from(form.querySelectorAll('[data-qty-minus],[data-qty-plus],[data-remove],input[data-line],[data-cart-checkout]'));
    const announce=(value)=>{
      if(!status)return;
      status.hidden=!value;
      status.textContent=value||'';
    };
    const unlock=()=>{
      busy=false;
      controls().forEach(control=>control.disabled=false);
    };
    if(!window.__pelmoriCartPageShowRecovery){
      window.__pelmoriCartPageShowRecovery=true;
      window.addEventListener('pageshow',event=>{
        if(!event.persisted)return;
        document.querySelectorAll('[data-cro-cart] [data-qty-minus], [data-cro-cart] [data-qty-plus], [data-cro-cart] [data-remove], [data-cro-cart] input[data-line], [data-cro-cart] [data-cart-checkout]').forEach(control=>control.disabled=false);
        document.querySelectorAll('[data-cro-cart] input[type="hidden"][name="checkout"]').forEach(input=>input.remove());
      });
    }
    const rerender=async(cart,focusLine)=>{
      if(!sectionId)throw new Error('Cart section ID unavailable');
      const url=root+'cart?sections='+encodeURIComponent(sectionId);
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('Could not refresh cart');
      const sections=await response.json();
      const html=sections&&sections[sectionId];
      if(!html)throw new Error('Cart section not available');
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('[data-cro-cart]');
      if(!fresh)throw new Error('Cart section markup missing');
      el.replaceWith(fresh);
      initCart(fresh);
      document.querySelectorAll('[data-cart-count]').forEach(node=>{node.textContent=String(cart.item_count);});
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
      if(focusLine){
        const target=fresh.querySelector('input[data-line="'+focusLine+'"]');
        if(target)target.focus({preventScroll:true});
      }
    };
    const update=async(checkout=false,focusLine=null)=>{
      if(busy)return;
      clearTimeout(debounce);
      busy=true;
      error.hidden=true;
      announce('Updating your cart…');
      const edits=inputs().map(input=>({
        line:Number(input.dataset.line),
        quantity:input.value==='0' ? 0 : Math.max(1,Math.min(99,Math.floor(Number(input.value)||1)))
      })).sort((a,b)=>b.line-a.line);
      controls().forEach(control=>control.disabled=true);
      let saved=false;
      try{
        let cart=await request(root,'cart.js');
        for(const edit of edits){
          if(cart.items[edit.line-1] && cart.items[edit.line-1].quantity!==edit.quantity)
            cart=await request(root,'cart/change.js',edit);
        }
        cart=await syncOffer(root,cart);
        saved=true;
        if(checkout){
          const hidden=document.createElement('input');
          hidden.name='checkout';
          hidden.type='hidden';
          hidden.value='Checkout';
          form.appendChild(hidden);
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        try{
          await rerender(cart,focusLine);
        }catch(renderError){
          window.location.reload();
        }
      }catch(failure){
        error.textContent=failure.message||labels.error;
        error.hidden=false;
        announce('');
        unlock();
      }
    };
    const schedule=(focusLine,immediate=false)=>{
      if(busy)return;
      clearTimeout(debounce);
      announce('Updating your cart…');
      debounce=setTimeout(()=>update(false,focusLine),immediate?0:300);
    };
    form.addEventListener('submit',event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      update(false);
    },true);
    checkoutButton?.addEventListener('click',event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      clearTimeout(debounce);
      update(true);
    },true);
    form.querySelectorAll('[data-qty-plus],[data-qty-minus]').forEach(button=>{
      button.addEventListener('click',()=>{
        const line=button.dataset.qtyPlus||button.dataset.qtyMinus;
        const input=form.querySelector('input[data-line="'+line+'"]');
        if(!input||busy)return;
        const direction=button.hasAttribute('data-qty-plus')?1:-1;
        input.value=String(Math.max(1,Math.min(99,Math.floor(Number(input.value)||1)+direction)));
        schedule(line);
      });
    });
    inputs().forEach(input=>{
      input.addEventListener('input',()=>{
        if(busy)return;
        const n=Number(input.value);
        if(input.value!=='' && Number.isInteger(n) && n>=1 && n<=99)schedule(input.dataset.line);
        else clearTimeout(debounce);
      });
      input.addEventListener('change',()=>{
        if(busy)return;
        input.value=String(Math.max(1,Math.min(99,Math.floor(Number(input.value)||1))));
        schedule(input.dataset.line);
      });
    });
    form.querySelectorAll('[data-remove]').forEach(button=>{
      button.addEventListener('click',()=>{
        const input=form.querySelector('input[data-line="'+button.dataset.remove+'"]');
        if(!input||busy)return;
        input.value='0';
        schedule(null,true);
      });
    });
    // Upgrade carts that still contain the previous customer-facing DRAFT code.
    // Only synchronize automatically when an obsolete house code is found.
    request(root,'cart.js').then(cart=>{
      if(busy)return;
      const obsolete=(cart.discount_codes||[]).some(discount=>discount.code.toUpperCase()==='PELMORI-WAKE-2-400-DRAFT');
      if(!obsolete)return;
      busy=true;
      announce('Updating your bundle discount…');
      return syncOffer(root,cart).then(updated=>rerender(updated)).catch(()=>window.location.reload());
    }).catch(()=>{});
  }
  function initQuick(form){
    if(form.dataset.ready)return;form.dataset.ready='true';
    const select=form.querySelector('select');
    select.addEventListener('change',()=>{const selected=select.selectedOptions[0];const image=form.closest('.cro-card').querySelector('img');image.src=selected.dataset.image;image.alt=selected.textContent;const button=form.querySelector('button');if(button.dataset.actionLabel&&selected.dataset.price)button.textContent=`${button.dataset.actionLabel} — ${selected.dataset.price}`;});
    form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;button.disabled=true;let added=false;const error=form.querySelector('[data-quick-error]');error.hidden=true;try{await request(form.dataset.root,'cart/add.js',{items:[{id:Number(select.value),quantity:1}]});added=true;await syncOffer(form.dataset.root,await request(form.dataset.root,'cart.js'));location.assign(form.dataset.cart || location.href);}catch(failure){if(added){location.assign(form.dataset.cart || location.href);return;}error.textContent=failure.message;error.hidden=false;button.disabled=false;}});
  }
  function initGallery(el){
    if(el.dataset.galleryReady)return;el.dataset.galleryReady='true';
    const image=el.querySelector('.cro-main-image img');
    const buttons=[...el.querySelectorAll('.cro-thumb[data-image]')];
    const tools=el.querySelector('[data-gallery-tools]');
    const dialog=el.querySelector('[data-zoom]');
    if(!image||!buttons.length||!tools||!dialog)return;
    let index=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
    const count=el.querySelector('[data-gallery-count]');
    const show=(position,move=false)=>{index=(position+buttons.length)%buttons.length;const button=buttons[index];image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.alt||'';buttons.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===index)));count.textContent=`${index+1} / ${buttons.length}`;if(move)button.scrollIntoView({block:'nearest',inline:'nearest'});};
    count.textContent=`${index+1} / ${buttons.length}`;tools.hidden=false;
    el.addEventListener('cro:variant-image',()=>{const match=buttons.findIndex(button=>new URL(button.dataset.image,location.href).pathname===new URL(image.src,location.href).pathname);if(match>=0)show(match);else count.textContent=`${buttons.length} gallery images`;});
    buttons.forEach((button,n)=>button.addEventListener('click',()=>show(n)));
    el.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(index-1,true));
    el.querySelector('[data-gallery-next]').addEventListener('click',()=>show(index+1,true));
    const thumbnails=el.querySelector('.cro-thumbnails');
    thumbnails.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1),true);buttons[index].focus();}});
    let startX=0,startY=0;const frame=el.querySelector('.cro-main-image');
    frame.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY;},{passive:true});
    frame.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-startX,dy=event.changedTouches[0].clientY-startY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy))show(index+(dx<0?1:-1),true);},{passive:true});
    el.querySelector('[data-zoom-open]').addEventListener('click',()=>{const copy=image.cloneNode();copy.removeAttribute('fetchpriority');copy.removeAttribute('loading');copy.removeAttribute('data-hero');dialog.querySelector('[data-zoom-content]').replaceChildren(copy);dialog.showModal();});
    el.querySelector('[data-zoom-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}});
  }
  const polishApps=()=>{const badge=document.querySelector('.bundle-aggregated_reviews');const title=document.querySelector('.pwb__buy h1,.cro-product-name');const serverSummary=document.querySelector('.pwb__buy .cro-review-summary,.cro-buy-box .cro-review-summary');if(badge&&serverSummary){badge.hidden=true;}else if(badge&&title&&title.nextElementSibling!==badge){title.after(badge);}if(badge&&!badge.dataset.croAccessible){badge.dataset.croAccessible='true';badge.tabIndex=0;badge.setAttribute('role','link');badge.setAttribute('aria-label','Read customer reviews');const go=()=>{document.getElementById('bundle-product_reviews')?.scrollIntoView({behavior:'smooth',block:'start'});};badge.addEventListener('click',go);badge.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();go();}});}document.querySelectorAll('dialog.Vtl-Popup.vitals_popup[open],#vitals_popup dialog[open]').forEach(popup=>{popup.close();if(!document.querySelector('dialog.Vtl-Modal[open]'))document.body.classList.remove('Vtl-Modal--Active');});};
  let scheduled=false;new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;polishApps();});}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
  const init=()=>{polishApps();document.querySelectorAll('[data-cro-product]').forEach(el=>{initProduct(el);initGallery(el);});document.querySelectorAll('[data-cro-cart]').forEach(initCart);document.querySelectorAll('[data-cro-quick]').forEach(initQuick);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
